// src/pages/ManageBuyPackage.js
import React, { useState, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart, faEye } from "@fortawesome/free-solid-svg-icons";
import {
  Breadcrumb,
  Card,
  Table,
  Badge,
  Button,
  Modal,
  Form,
  Row,
  Col,
  InputGroup,
} from "@themesberg/react-bootstrap";

// ===== helpers =====
const baht = (n) => `฿${Number(n).toLocaleString()}`;
const PaymentBadge = ({ status }) => {
  if (status === "PAID") return <Badge bg="success">ชำระแล้ว</Badge>;
  if (status === "PENDING")
    return (
      <Badge bg="danger">
        ค้างชำระ
      </Badge>
    );
  return <Badge bg="secondary">-</Badge>;
};

// ===== mock data =====
const INITIAL_ORDERS = [
  {
    org: "ห้างหุ้นส่วนจำกัด ผ้าห้อมหอม (สำนักงานใหญ่)",
    pkg: "Forever",
    start: "1 ต.ค. 2562",
    end: "31 ธ.ค. 2643",
    price: 0.0,
    payment: "PAID",
  },
  {
    org: "ห้างหุ้นส่วนจำกัด ผ้าห้อมหอม (สำนักงานใหญ่)",
    pkg: "Forever",
    start: "1 ต.ค. 2562",
    end: "31 ธ.ค. 2643",
    price: 0.0,
    payment: "PENDING",
  },
];

const PageTrafficTable = ({ rows }) => {
  const RowItem = ({ idx, r }) => (
    <tr>
      <td>{idx}</td>
      <td className="fw-bold">{r.org}</td>
      <td>{r.pkg}</td>
      <td>{r.start}</td>
      <td>{r.end}</td>
      <td className="text-end">{baht(r.price)}</td>
      <td>
        <PaymentBadge status={r.payment} />
      </td>
    </tr>
  );

  return (
    <Card border="light" className="shadow-sm mb-4">
      <Card.Body className="pb-0">
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              <th className="border-0">#</th>
              <th className="border-0">องค์กร</th>
              <th className="border-0">แพ็คเกจ</th>
              <th className="border-0">วันที่เริ่มต้น</th>
              <th className="border-0">วันที่สิ้นสุด</th>
              <th className="border-0 text-end">ราคา</th>
              <th className="border-0">การชำระ</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <RowItem key={`order-${i}`} idx={i + 1} r={r} />
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

// ===== main page (มีปุ่ม + popup) =====
export default function ManageBuyPackage() {
  // data ของตาราง
  const [orders, setOrders] = useState(INITIAL_ORDERS);

  // modal state
  const [showBuy, setShowBuy] = useState(false);

  // form state
  const [org, setOrg] = useState("");
  const [pkg, setPkg] = useState("Starter 1M");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [price, setPrice] = useState(0);
  const [payment, setPayment] = useState("PENDING");

  const total = useMemo(() => Number(price || 0), [price]);

  const resetForm = () => {
    setOrg("");
    setPkg("Starter 1M");
    setStart("");
    setEnd("");
    setPrice(0);
    setPayment("PENDING");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // เพิ่มลงตารางทันที (mock)
    setOrders((prev) => [
      ...prev,
      { org, pkg, start, end, price: Number(price), payment },
    ]);
    setShowBuy(false);
    resetForm();
  };

  return (
    <>
      {/* header */}
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          />
          <h4>รายการผู้สมัครใช้งาน</h4>
        </div>
        {/* <div className="btn-toolbar gap-2 mb-2 mb-md-0">
          <Button variant="success" onClick={() => setShowBuy(true)}>
            <FontAwesomeIcon icon={faShoppingCart} className="me-2" />
            ซื้อแพ็คเกจ
          </Button>
        </div> */}
      </div>

      {/* table */}
      <PageTrafficTable rows={orders} />

      {/* popup: ซื้อแพ็คเกจ */}
      <Modal
        show={showBuy}
        onHide={() => setShowBuy(false)}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>ซื้อแพ็คเกจ</Modal.Title>
        </Modal.Header>

        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Row className="g-2">
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>องค์กร / ลูกค้า</Form.Label>
                  <Form.Select
                    value={pkg}
                    onChange={(e) => setPkg(e.target.value)}
                  >
                    <option>ห้างหุ้นส่วนจำกัด ผ้าห้อมหอม (สำนักงานใหญ่)</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group>
                  <Form.Label>แพ็คเกจ</Form.Label>
                  <Form.Select
                    value={pkg}
                    onChange={(e) => setPkg(e.target.value)}
                  >
                    <option>Forever</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowBuy(false)}>
              ยกเลิก
            </Button>
            <Button type="submit" variant="primary">
              ยืนยันการซื้อ
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}
